// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"19":"blog","40":"debug","75":"mc","472":"settings","792":"main"}[chunkId] + "-" + {"19":"91580","40":"75d2f","75":"b3ccc","472":"11413","792":"149a2"}[chunkId] + ".js";
};